import React,{useState,useEffect} from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import PunchoutOrderDetails from '../../components/Punchout/PunchoutOrderDetails'
import { useParams , useSearchParams,useNavigate } from "react-router-dom";

const PunchoutOrderDetailPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [refnum, setRefnum] = useState(false);
    useEffect(async () => {
        if(searchParams.get("refnum"))setRefnum({refnum:searchParams.get("refnum")});
      }, [searchParams])

    return (
        <>
            <Helmet>
                <title>Order Info</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            {refnum && <PunchoutOrderDetails refnum={refnum.refnum}/>}
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default PunchoutOrderDetailPage